import { render, staticRenderFns } from "./STextArea.vue?vue&type=template&id=5d9e8c33"
import script from "./STextArea.vue?vue&type=script&lang=js"
export * from "./STextArea.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports